import { useQuery } from '@tanstack/react-query';
import {
  API_JSON_CONTENT_TYPE,
  createEndpointFetch,
} from '@web-config-app/api';
import { DmlResponse, EnvironmentKey } from '@web-config-app/core';
import { useEnvironmentFetch } from '../use-environment-fetch/use-environment-fetch';

interface UseDMLProps {
  environmentKey: EnvironmentKey;
  path?: string;
}

export const useDML = ({ environmentKey, path }: UseDMLProps) => {
  const headers = {
    'Content-Type': API_JSON_CONTENT_TYPE,
  };

  const environmentFetch = useEnvironmentFetch(environmentKey);

  const queryFn = path
    ? async () => {
        const endpointConfig = {
          path,
          method: 'GET',
        } as const;

        const dmlFetch = createEndpointFetch<DmlResponse>(
          endpointConfig,
          environmentFetch,
        );

        return dmlFetch({
          headers,
        });
      }
    : undefined;

  /**
   * We rename the data returned by useQuery so we can differentiate the data from our API response which
   * also has a `data` property. This avoids a result with a `result.data.data` structure.
   */

  const { data: queryResultData, ...queryResult } = useQuery({
    queryKey: ['dml', path, environmentKey],
    queryFn,
    enabled: !!path,
    staleTime: Infinity,
  });
  return {
    ...queryResult,
    data: queryResultData?.data,
  };
};
